import PaymentAttentionList from './PaymentAttentionTables'
import { Route, Routes, useLocation } from 'react-router-dom'
import { FailedPspNotificationDetails } from './FailedNotifications/FailedPspNotificationDetails'
import { NonCapturedPaymentDetails } from './NonCapturedPayments/NonCapturedPaymentDetails'
import { UnknownPaymentDetails } from './UnknownStatePayments/UnknownPaymentDetails'
import { usePaymentOperations } from './context/PaymentOperationsContext'
import { useEffect } from 'react'

const ScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}

const PaymentOperationsOverview = () => {
    const { data, isLoading } = usePaymentOperations()

    if (!data || isLoading) {
        return <p>Loading...</p>
    }

    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route
                    path="psp-notifications/:pspNotificationId"
                    element={<FailedPspNotificationDetails failedPspNotifications={data.failedPspNotifications} />}
                />

                <Route
                    path="non-captured-payments/:paymentReference"
                    element={<NonCapturedPaymentDetails nonCapturedPayments={data.nonCapturedPayments} />}
                />
                <Route path="unknown-state/:paymentReference" element={<UnknownPaymentDetails />} />
                <Route
                    path=":section?"
                    element={
                        <PaymentAttentionList
                            failedPspNotifications={data?.failedPspNotifications ?? []}
                            nonCapturedPayments={data?.nonCapturedPayments ?? []}
                            unknownStatePayments={data?.unknownStatePayments ?? []}
                        />
                    }
                ></Route>
            </Routes>
        </>
    )
}

export default PaymentOperationsOverview
